(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/result/assets/javascripts/views/andra-chansen-winner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/result/assets/javascripts/views/andra-chansen-winner.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const asyncCampaignApi = svs.numbergames.campaign.asyncCampaignApi;
svs.lotto.components.result.views.AndraChansenWinner = Marionette.View.extend({
  modelEvents: {
    'change:selectedDate': 'updateWinningLocations'
  },
  template(data) {
    var _data$winningLocation;
    return (_data$winningLocation = data.winningLocations) !== null && _data$winningLocation !== void 0 && _data$winningLocation.count ? svs.lotto.components.result.templates.andra_chansen_winner(data) : false;
  },
  templateContext() {
    var _this$winningLocation, _this$winningLocation2, _this$winningLocation3;
    const isMultipleLocations = ((_this$winningLocation = this.winningLocations) === null || _this$winningLocation === void 0 ? void 0 : _this$winningLocation.count) > 1;
    let processedCities = (_this$winningLocation2 = this.winningLocations) === null || _this$winningLocation2 === void 0 ? void 0 : _this$winningLocation2.cities;

    if (isMultipleLocations && (_this$winningLocation3 = this.winningLocations) !== null && _this$winningLocation3 !== void 0 && _this$winningLocation3.cities) {
      processedCities = this.winningLocations.cities.map((city, index) => {
        const colInGroup = index % 10;
        const className = colInGroup >= 3 && colInGroup <= 6 ? 'col-4' : 'col-3';
        return {
          name: city,
          className
        };
      });
    }
    return {
      isMultipleLocations,
      winningLocations: _objectSpread(_objectSpread({}, this.winningLocations), {}, {
        cities: processedCities
      })
    };
  },
  initialize() {
    this.updateWinningLocations();
  },
  async updateWinningLocations() {
    const selectedDate = this.model.get('selectedDate');
    const endDateInterval = {
      start: selectedDate,
      end: dateFns.endOfDay(new Date(selectedDate))
    };
    this.winningLocations = await asyncCampaignApi.getWinningLocationTexts(this.model.get('productId'), {
      endDateInterval
    });
    this.render();
  }
});

 })(window);